exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".products{margin:15px 20px 0}.products .product{border:1px solid #eee;margin-top:15px;display:block;color:#333}.products .product .tag{margin-top:3px;padding:2px 4px;border-radius:3px;background:green;color:#fff}.products .product .LazyLoad{opacity:0;transition:all .5s ease-in-out;background:#f5f5f5;height:200px}.products .product .LazyLoad.is-visible{opacity:1}@media only screen and (min-width:600px){.products .product .LazyLoad{height:556px}}.products .product .cover{height:200px;width:100%;object-fit:cover}@media only screen and (min-width:600px){.products .product .cover{height:auto}}.products .product .left-content{width:calc(100vw - 110px)}@media only screen and (min-width:600px){.products .product .left-content{width:90%}}.products .product .title{font-weight:700;font-size:14px;text-align:justify}.products .product .price{color:red;font-size:14px;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/develop/Products.scss
// module id = 612
// module chunks = 0